import * as React from 'react'
const SvgDeleteAxesInactive = props => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 10H26" stroke="#00293B"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M22.7998 10H8.7998V25H22.7998V10Z" stroke="#00293B"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 10H11.5V6H20.5V10Z" stroke="#00293B"/>
    <path d="M16 13V22" stroke="#00293B"/>
    <path d="M12.4004 13V22" stroke="#00293B"/>
    <path d="M19.4004 13V22" stroke="#00293B"/>
  </svg>
)

export default SvgDeleteAxesInactive